import React, { useState, useRef, useEffect } from 'react';
import { Stage, Layer, Rect } from 'react-konva';
import {  Container, Column, Button} from './Canvas.styles.js';
import { defaultBackgroundImages,  cutOptions, suportOptions, useOptions, NEON_COLORS, NEON_FONTS, CANVAS_WIDTH, CANVAS_HEIGHT} from '../../constants/options';
import PurchaseForm from '../Forms/PurchaseForm.jsx';
import BackgroundManager from './subCanvas/BackgroundManager';
import TextManager from './subCanvas/TextManager';
import ImageManager from './subCanvas/ImageManager';
import ConfigPanel from './subCanvas/ConfigPanel';

const Canvas = () => {
  const [contentType, setContentType] = useState('text');
  const [texts, setTexts] = useState([
    {
      id: Date.now(),
      text: 'ESCRIBE TU NEÓN',
      x: 250 - 300, 
      y: 250,  
      fontFamily: NEON_FONTS[0].value,
      color: NEON_COLORS[0].value,
      fontSize: 35,
      offsetX: 0,
      offsetY: 0,
    },
  ]);
  const [selectedTextId, setSelectedTextId] = useState(texts[0]?.id || null);
  const [selectedImageId, setSelectedImageId] = useState(null); 
  const [backgroundSrc, setBackgroundSrc] = useState(defaultBackgroundImages[0].src);
  const [backgroundImages, setBackgroundImages] = useState([...defaultBackgroundImages]);
  const [uploadedImageSrc, setUploadedImageSrc] = useState(null);
  const [uploadedImages, setUploadedImages] = useState([]);
  const [description, setDescription] = useState('');
  const [changeForm, setChangeForm] = useState(false);
  const [size, setSize] = useState({ width: '', height: '' });
  const [cut, setCut] = useState('');
  const [support, setSupport] = useState('');
  const [use, setUse] = useState('');
  const stageRef = useRef(null);

  useEffect(() => {
    setCut(cutOptions[0].value);
    setSupport(suportOptions[0].value);
    setUse(useOptions[0].value);
  }, []);

  const handleDeselect = () => {
    setSelectedTextId(null);
    setSelectedImageId(null);
  };

  const handleBackToCanvas = (canvasData) => {
    setContentType(canvasData.contentType);
    setTexts(canvasData.texts);
    setBackgroundSrc(canvasData.backgroundSrc);
    setUploadedImages(canvasData.uploadedImages);
    setDescription(canvasData.description);
    setSize(canvasData.size);
    setCut(canvasData.cut);
    setSupport(canvasData.support);
    setUse(canvasData.use);
    setChangeForm(false);
  };

  const handleContentTypeChange = (value) => {
    setContentType(value);
    setUploadedImageSrc(null);
  };

  return (
    <Container>
      <Column>
        <Stage ref={stageRef} width={CANVAS_WIDTH} height={CANVAS_HEIGHT} style={{ borderRadius: '10px', overflow: 'hidden', border: '2px solid #ccc' }}>
          <Layer>
            <BackgroundManager 
              CANVAS_WIDTH={CANVAS_WIDTH}
              CANVAS_HEIGHT={CANVAS_HEIGHT}
              backgroundSrc={backgroundSrc}
              setBackgroundSrc={setBackgroundSrc}
              backgroundImages={backgroundImages}
              setBackgroundImages={setBackgroundImages}
            />
          </Layer>
          <Layer>
            <Rect
              width={CANVAS_WIDTH}
              height={CANVAS_HEIGHT}
              fill="transparent"
              onClick={handleDeselect} 
            />
            
            {contentType === 'text' && (
              <TextManager
                CANVAS_WIDTH={CANVAS_WIDTH}
                CANVAS_HEIGHT={CANVAS_HEIGHT}
                texts={texts}
                setTexts={setTexts}
                selectedTextId={selectedTextId}
                setSelectedTextId={setSelectedTextId}
                fontLoaded={true}
              />
            )}
            
            {contentType === 'image' && (
              <ImageManager
                CANVAS_WIDTH={CANVAS_WIDTH}
                CANVAS_HEIGHT={CANVAS_HEIGHT}
                uploadedImageSrc={uploadedImageSrc}
                uploadedImages={uploadedImages}
                selectedImageId={selectedImageId} 
                setSelectedImageId={setSelectedImageId} 
              />
            )}
          </Layer>
        </Stage>
      </Column>
      <Column>
        {changeForm ? (
          <PurchaseForm 
          stageRef={stageRef}
          contentType={contentType}
          texts={texts}
          backgroundSrc={backgroundSrc}
          uploadedImages={uploadedImages}
          description={description}
          size={size}
          cut={cut}
          support={support}
          use={use}
          setSelectedTextId={setSelectedTextId}
          setSelectedImageId={setSelectedImageId}
          onBack={handleBackToCanvas} />
        ) : (
          <ConfigPanel
            contentType={contentType}
            onContentTypeChange={handleContentTypeChange}
            texts={texts}
            setTexts={setTexts}
            selectedTextId={selectedTextId}
            setSelectedTextId={setSelectedTextId}
            uploadedImages={uploadedImages}
            setUploadedImages={setUploadedImages}
            uploadedImageSrc={uploadedImageSrc}
            setUploadedImageSrc={setUploadedImageSrc}
            description={description}
            setDescription={setDescription}
            size={size}
            setSize={setSize}
            cut={cut}
            setCut={setCut}
            support={support}
            setSupport={setSupport}
            use={use}
            setUse={setUse}
          />
        )}
        
        {!changeForm && (
          <Button onClick={() => setChangeForm(true)}>¡COMPRAR YA!</Button>
        )}
      </Column>
    </Container>
  );
};

export default Canvas;